import { APIClient } from '../../helpers/api_helper';
const AxiosClient = new APIClient()
export const getAllUnreadNotificationCount = () => AxiosClient.get("/notification/unread-count");
export const getAllNotificationList = (query) => AxiosClient.get("/notification", query);
export const markAsReadNotification = (payload) => AxiosClient.put("/notification/mark-as-read", payload);
export const markAllReadNotification = () => AxiosClient.put("/notification/mark-all-read");
export const deleteNotification = (payload) => AxiosClient.delete("/notification", { data: payload });
